module.exports = __webpack_public_path__ + "img/help-center-bg.f8dbd81a.png";